// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"76fe356154cb980cc7a0","655":"f91a1a78d7515abe729b"}[chunkId] + ".js";
};